// Terms and conditions (owner, 5 Nov 2026: "can you also update /term-condition and
// /privacy-policy"): the owner's words from /languages in the legal layout
// (components/landing/LegalPage): night hero, "On this page", a reading column and a
// closing card with the contact email. One fix to the old order: "Amendments" sat empty
// while its text (para13) showed under "Contact Information Collection"; each heading
// now has its own paragraph.
import React from 'react';
import { useSelector } from 'react-redux';
import { GavelRounded } from '@mui/icons-material';
import LegalPage, { LegalP, legalHeading } from '../components/landing/LegalPage';
import { useSiteWords } from '../components/landing/SitePage';

// [heading key, paragraph key] pairs, in the old order.
const SECTIONS = [
  ['term_condition_heading1', 'term_condition_para2'],
  ['term_condition_heading2', 'term_condition_para3'],
  ['term_condition_heading3', 'term_condition_para4'],
  ['term_condition_heading4', 'term_condition_para5'],
  ['term_condition_heading5', 'term_condition_para6'],
  ['term_condition_heading6', 'term_condition_para7'],
  ['term_condition_heading7', 'term_condition_para8'],
  ['term_condition_heading8', 'term_condition_para9'],
  ['term_condition_heading9', 'term_condition_para10'],
  ['term_condition_heading10', 'term_condition_para11'],
  ['term_condition_heading11', 'term_condition_para12'],
  ['term_condition_heading12', 'term_condition_para13'],
  ['term_condition_heading15', 'term_condition_para15'],
];

export default function TermCondition(props) {
  const { t, L } = useSiteWords();
  const settings = useSelector((state) => state.settingsdata.settings) || {};
  const sections = SECTIONS.map(([heading, para]) => ({
    id: 'tc-' + heading.replace('term_condition_heading', ''),
    heading: legalHeading(t(heading)),
    body: <LegalP>{t(para)}</LegalP>,
  }));

  return (
    <LegalPage
      mainId="tc-main"
      heroId="tc-title"
      icon={<GavelRounded />}
      title={t('term_condition')}
      sub={L('lg_terms_sub', 'The terms for using Donkey Drive, as a customer or as a driver.')}
      intro={<LegalP>{t('term_condition_para1')}</LegalP>}
      sections={sections}
      closing={{ id: 'tc-questions', heading: L('lg_questions_title', 'Questions?'), text: t('term_condition_para14'), email: settings.contact_email }}
      {...props}
    />
  );
}
